import { useState } from 'react'

import CircularProgress from '@mui/material/CircularProgress'

import { Flex, FlexContainer } from 'components/Flex'
import ListItem from 'components/ListItem'
import Panel from 'components/Panel'
import { useDocs } from 'lib/firestore'

import MailTemplateDialog from './MailTemplateDialog'

export default function MailTemplateList() {
  const [data, setData] = useState(null)
  const { items } = useDocs('templates')

  if (!items) {
    return (
      <FlexContainer style={{ alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </FlexContainer>
    )
  }

  return (
    <Flex>
      <Panel>
        {items.map(x => (
          <ListItem key={x.id} primary={x.title} onClick={() => setData(x)} />
        ))}
      </Panel>
      {data && <MailTemplateDialog data={data} onClose={() => setData(null)} />}
    </Flex>
  )
}
